import {Component} from '@angular/core';
import {Events, IonicPage, MenuController, NavController, Platform} from 'ionic-angular';
import {ProofAfterEndPage} from '../proof-after-end/proof-after-end';

import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {ProofProvider} from '../../providers/proof/proof';
import {AlertProvider} from '../../providers/alert/alert';

import {PeripheralCheckPage} from '../peripheral-check/peripheral-check';

/**
 * Generated class for the ProofTermsPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-proof-terms',
  templateUrl: 'proof-terms.html',
})
export class ProofTermsPage {

  public terms: string;
  public agreement: boolean;

  constructor(
    private navCtrl: NavController,
    private menu: MenuController,
    private platform: Platform,
    private networkMonitor: NetworkMonitorProvider,
    private proofProvider: ProofProvider,
    private alertProvider: AlertProvider,
    private events: Events
  ) {
    let that = this;

    this.menu.enable(false);
    this.menu.swipeEnable(false);

    this.proofProvider.isFinished().subscribe((finished: boolean): void => {
      if (finished) {
        that.navCtrl.push(ProofAfterEndPage);
      } else {
        if (that.platform.is('cordova')) {
          this.networkMonitor.start();
        } /*else if (proofProvider.isWebWithoutCamera()) {
          let message = 'Nessa modalidade você precisará sempre fazer nova prova para renovação. Caso escolha modalidade com câmera, sua renovação poderá ser feita sem necessidade de prova.';
          let agreeLabel = 'Quero alterar para Web com Câmera';
          let disagreeLabel = 'Quero continuar na modalidade sem câmera';

          that.alertProvider.doConfirm(message, () => {
            that.proofProvider.setWebcamRequired(true);
            that.alertProvider.doInfoAlert('Alterado para Web com Câmera.');
          }, () => { }, agreeLabel, disagreeLabel);
        }*/

        that.terms = proofProvider.getTerms();
        that.agreement = false;
      }
    });
  }

  public ionViewWillLeave(): void {
    if (this.agreement) {
      return;
    }

    this.menu.enable(true);
    this.menu.swipeEnable(true);

    this.events.unsubscribe('doProofUpdate');
  }

  public doContinue(): void {
    if (!this.agreement) {
      return;
    }

    this.navCtrl.push(PeripheralCheckPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/proof-terms/proof-terms.ts